module.exports = __webpack_public_path__ + "img/img-intro1@2x.1b23b812.jpg";